var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-editor',{staticStyle:{"min-height":"300px"},attrs:{"config":_vm.config,"useCustomImageHandler":""},on:{"image-added":_vm.handleImageAdded},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }